import { ChangeDetectorRef, Component, ElementRef } from '@angular/core'
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { Address, EventService, SiteConnector, WindowRef } from '@spartacus/core'
import { MbCheckoutCommonService } from 'src/app/mb/checkout/services/mb-checkout-common.service'
import { MbCheckoutStepService } from 'src/app/mb/checkout/services/mb-checkout-step.service'
import { MbCheckoutBillingAddressFormBase } from '../mb-checkout-billing-address-form-base'
import { MbCheckoutBillingFacade } from '../../../../facades/mb-checkout-billing.facade'
import { checkoutValidationRules } from 'src/app/mb/shared/mb-constants'
import { ActiveCartService } from '@spartacus/cart/base/core'

@Component({
  selector: 'mb-checkout-billing-address-form-au',
  templateUrl: './mb-checkout-billing-address-form-au.component.html',
  styleUrls: ['../mb-checkout-billing-address-form-base.scss']
})
export class MbCheckoutBillingAddressFormAuComponent extends MbCheckoutBillingAddressFormBase {

  constructor (protected activatedRoute: ActivatedRoute,
               protected mbCheckoutStepService: MbCheckoutStepService,
               protected siteConnector: SiteConnector,
               protected activeCartService: ActiveCartService,
               protected mbCheckoutCommonService: MbCheckoutCommonService,
               protected mbCheckoutBillingFacade: MbCheckoutBillingFacade,
               protected cdRef: ChangeDetectorRef,
               protected winRef: WindowRef,
               protected el: ElementRef,
               protected eventService: EventService) {
    super(activatedRoute,
      mbCheckoutStepService,
      siteConnector,
      activeCartService,
      mbCheckoutCommonService,
      mbCheckoutBillingFacade,
      cdRef,
      winRef,
      el,
      eventService
    )
  }

  override convert (source?: Address, target?: Address) {
    if (!source || !target) {
      return
    }

    target.companyName = source.companyName
    target.institute = source.institute
    target.department = source.department
    target.building = source.building
    target.lab = source.lab
    target.streetInformation = source.streetInformation
    target.postalCode = source.postalCode
    target.town = source.town
    target.country = source.country
    target.region = source.region

    this.onStateSelection(source.region)
  }

  override convertCheckoutBillingInformationModel2Form () {
    return new UntypedFormGroup({
      companyName: new UntypedFormControl(this.billingAddress?.companyName, [Validators.required,
        Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)]),
      institute: new UntypedFormControl(this.billingAddress?.institute,
        Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)),
      department: new UntypedFormControl(this.billingAddress?.department,
        Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)),
      building: new UntypedFormControl(this.billingAddress?.building,
        Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)),
      lab: new UntypedFormControl(this.billingAddress?.lab, Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)),
      streetInformation: new UntypedFormControl(this.billingAddress?.streetInformation, [Validators.required,
        Validators.maxLength(checkoutValidationRules.checkoutStringMaxLength)]),
      postalCode: new UntypedFormControl(this.billingAddress?.postalCode, Validators.required),
      town: new UntypedFormControl(this.billingAddress?.town, Validators.required),
      country: new UntypedFormControl(this.isCountryDisabled(), Validators.required),
      region: new UntypedFormControl(this.billingAddress?.region, Validators.required),
      id: new UntypedFormControl(this.billingAddress?.id)
    })
  }

  override convertCheckoutBillingInformationForm2Model () {
    this.billingAddress = {
      ...this.billingAddress,
      companyName: this.billingForm.get(this.constants.COMPANY_CODE)?.value,
      institute: this.billingForm.get(this.constants.INSTITUTE_CODE)?.value,
      department: this.billingForm.get(this.constants.DEPARTMENT_CODE)?.value,
      building: this.billingForm.get(this.constants.BUILDING_CODE)?.value,
      lab: this.billingForm.get(this.constants.LAB_CODE)?.value,
      streetInformation: this.billingForm.get(this.constants.STREET_INFORMATION)?.value,
      postalCode: this.billingForm.get(this.constants.POSTAL_CODE_CODE)?.value,
      town: this.billingForm.get(this.constants.TOWN_CODE)?.value,
      country: this.country,
      region: this.billingForm.get(this.constants.REGION_CODE)?.value,
      id: this.billingForm.get(this.constants.ID_LOWER_CASE)?.value
    }
    this.billingInformation = {
      ...this.billingInformation,
      billingAddress: this.billingAddress,
      paymentModeSelection: this.paymentModeSelection
    }
  }
}
